import React, { MouseEventHandler } from 'react'
import { Button, ModalBody, ModalFooter, ModalTitle } from 'react-bootstrap'
import Modal from "react-bootstrap/Modal";
import ModalHeader from 'react-bootstrap/esm/ModalHeader'
type Props = {
    show: boolean,
    setShow: Function,
    title: any,
    description: string,
    component: Function,
    classNames: string,
    size: "lg" | "sm" | "xl" | undefined,
    confirmButtonText: string,
    cancelButtonText: string,
    confirmAction: MouseEventHandler<HTMLElement>,
    footerComponent: Function,
    backdrop: boolean
}

const GModal = ({ show = false, setShow, title, description = "", component, classNames = "", size = "lg",
    confirmButtonText = "", cancelButtonText = "", confirmAction = () => { }, footerComponent, backdrop = false }: Props) => {
    return (
        <Modal
            show={show}
            onHide={() => setShow(false)}
            onClose={() => setShow(false)}
            className={classNames}
            backdrop={backdrop ? "static" : true}
            keyboard={backdrop}
            size={size}
        >
            <Modal.Header onHide={() => setShow(false)}>
                <ModalTitle>{typeof title === 'string' ? title : typeof title === 'function' ? title() : '---'}</ModalTitle>
            </Modal.Header>
            <Modal.Body>{component ? component() : description}</Modal.Body>
            <Modal.Footer>
                {!footerComponent ?
                    <>
                        <Button color="secondary" onClick={() => setShow(false)}>
                            {cancelButtonText}
                        </Button>
                        {confirmButtonText && <Button color="primary" onClick={confirmAction}>{confirmButtonText}</Button>}</>
                    : footerComponent({ setShow })}
            </Modal.Footer>
        </Modal>
    )
}

export default GModal